/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import MyLocationIcon from '@mui/icons-material/MyLocation';
import {
  Card,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from "@mui/material";
import Auto from "components/AutoComplete/AutoComplete";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DisplayMapModal from "components/displayModel/displayMapModel";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MuiPhoneNumber from "material-ui-phone-number";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { addEditCustomerAddress, getAddressByID } from "utils/api";
import { generateDataList, handleStreetAddress, showResMsg, validateField, validatePhoneNumberField } from "utils/generic";
import LoadingModal from "../../components/LoadingModel/loadingModal";




const errMsg = {
  color: `red`,
  fontSize: `11px`,
};







function AddAddressHistory() {
  const { id } = useParams();
  const { customerID } = useParams();


  const stateListRef = useRef([]);
  const countryListRef = useRef([]);
  const [screenName, setScreenName] = useState("Add Address");
  const [loading, setLoading] = useState(false);
  const [userTypeErr, setUserTypeErr] = useState(false);
  const [firstNameErr, setFirstNameErr] = useState(false);
  const [mobileNumberErr, setMobileNumberErr] = useState(false);
  const [pNumberErrMsg, setpNumberErrMsg] = useState('');
  const [streetAddressErr, setStreetAddressErr] = useState(false);
  const [cityErr, setCityErr] = useState(false);
  const [zipCodeErr, setZipCodeErr] = useState(false);
  const [state, setState] = useState('');
  const [country, setCountry] = useState('');
  const [controller] = useMaterialUIController();
  const { sidenavColor, } = controller;
  const [uiVisiblity, SetUivisibility] = useState(false)
  const [displayDialogeFlag, setDisplayDialogeFlag] = useState(false);
  const [locationLongitude, setLocationLongitude] = useState(0);
  const [locationLatitude, setLocationLatitude] = useState(0);
  const [displayDialogemap, setDisplayDialogeMap] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let countryData = useSelector((state) => state.countryState.countryStateMenu.country)
  let stateData = useSelector((state) => state.countryState.countryStateMenu.state)
  const [values, setValues] = React.useState({
    countryCode: "",
    customerType: "Business",
    businessName: "",
    businessID: "",
    websiteName: "",
    firstName: "",
    lastName: "",
    emailAddress: "",
    phoneNumber: "+61",
    streetAddress: "",
    city: "",
    zipCode: "",
    stateId: "",
    countryId: "",
    addressType: "Home",
    locationLatitude: "",
    locationLongitude: "",
    paymentType: "Self-Payment",
    accountNumber: "",
    customerStatus: "Active",
    notes: "",
    contactName: "",
    businessUserID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS')).businessUserID
  });
  if (customerID !== undefined) {
    values.customerID = customerID
  }
  if (id !== undefined) {
    values.id = id

  }
  const handleChange = (name) => (event) => {
    if (event.target.validity !== undefined && event.target.validity.valid === true) {
      setValues({ ...values, [name]: event.target.value });
    }
    else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }
  };

  let mandateFlag = false;
  useEffect(() => {
    if (id !== undefined) {
      setScreenName("Edit Address")
      values.id = id;
      getAddressByID(values, (data) => {
        setValues(data.Result_Output)
      }, dispatch)

    } else SetUivisibility(true);
  }, []);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get('type')
    if (paramValue !== "" && paramValue !== undefined) {
      values.addressCategory = paramValue
    }
    (async () => {
      stateListRef.current = stateData;
      countryListRef.current = countryData;
      setCountry(await generateDataList(countryData, "_id", "countryName"));
      setState(await generateDataList(stateData, "_id", "stateName"));
    })()

  }, []);


  const clearErrorStates = () => {
    setFirstNameErr(false)
  };
  const addCustomer = (e) => {
    mandateFlag = false;
    clearErrorStates()
    mandateFlag = validateField(values.contactName, setFirstNameErr) || mandateFlag;
    mandateFlag = validatePhoneNumberField(values.phoneNumber, setMobileNumberErr, setpNumberErrMsg) || mandateFlag;
    mandateFlag = validateField(values.streetAddress, setStreetAddressErr) || mandateFlag;
    if (mandateFlag) {
      return;
    }
    addEditCustomerAddress(values, (data) => {
      showResMsg(data.Result_Message, 1000, data.Result_Status, navigate, sessionStorage.getItem("ORDER_ROUTE"));
    }, dispatch)
  };

  const handleDisplayDialogeMap = async () => {
    setDisplayDialogeMap(!displayDialogemap);
  }

  const handleDisplay = async (id) => {
    setDisplayDialogeFlag(!displayDialogeFlag);
  };

  const handleCancel2 = name => event => {
    setDisplayDialogeMap(false);
  };

  const handleCoordinateChange = (newCoordinates) => {
    values.locationLatitude = newCoordinates.lat
    values.locationLongitude = newCoordinates.lng

  }; const handleCancel = name => event => {
    setDisplayDialogeMap(false);
  };


  const handleStreetOnChange = (e) => {
    if (e.target.value === "") {
      setValues((prevValues) => ({
        ...prevValues,
        streetAddress: "",
        city: "",
        countryId: "",
        zipCode: "",
        stateId: "",
      }));
    } else {
      setValues((prevValues) => ({
        ...prevValues,
        streetAddress: e.target.value,
      }));
    }
  }

  const setPhoneValues = (phone, country) => {
    values.onlyPhoneNumber = phone.slice(country.dialCode.length);
    console.log("phone", phone.slice(country.dialCode.length));
    values.phoneNumber = phone.slice(country.dialCode.length);
    values.phoneNumber = phone
    values.countryCode = "+" + country.dialCode;
  };


  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleKeyDown = (e) => {
    const inputElement = document.querySelector('.GoogleInput');
    if (e.key === "Enter" && inputElement && inputElement.contains(e.target)) {
      e.preventDefault();
    }
  };



  return (
    <DashboardLayout>
      <DashboardNavbar screenName=" Edit Standard Plan Feature" />
      <MDBox mt={6} mb={3}>
        <form >
          <Grid container spacing={2}>
            <Grid item xs={12} spacing={6}>
              <Card sx={{ boxShadow: "none" }}>
                <MDBox
                  mx={2}
                  mt={-3}
                  mb={1.5}
                  py={2}
                  px={2}
                  variant="gradient"
                  bgColor={sidenavColor}
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    {screenName}
                  </MDTypography>
                </MDBox>
                <MDBox pt={4} pb={3} px={3}>
                  <Grid container columnSpacing={5}>
                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Business Name"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 30
                            }}
                            value={values.contactName}
                            onChange={handleChange("contactName")}
                          />
                          {firstNameErr ? <span style={errMsg}>Contact Name can't be blank</span> : ""}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <MuiPhoneNumber
                            defaultCountry={"australia"}
                            type="text"
                            label="Mobile Number"
                            variant="outlined"
                            fullWidth
                            value={values.phoneNumber}
                            onChange={(phone, country) => setPhoneValues(phone, country)}
                          // disabled={readOnly}
                          />
                          {mobileNumberErr ? <span style={errMsg}>{pNumberErrMsg}</span> : ""}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={5.6}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <Auto onChange={handleStreetOnChange}

                            onPlaceSelected={(place, e) => handleStreetAddress(place, e, (data) => {
                              setValues((prevValues) => ({
                                ...prevValues,
                                zipCode: data.zipCode,
                                city: data.city,
                                countryId: data.countryId,
                                stateId: data.stateId,
                                streetAddress: data.streetAddress,
                                locationLatitude: data.locationLatitude,
                                locationLongitude: data.locationLongitude
                              }));
                              setLocationLatitude(data.locationLatitude);
                              setLocationLongitude(data.locationLongitude);
                            }, stateListRef, countryListRef)} value={values.streetAddress} />
                          {streetAddressErr ? <span style={errMsg}>Street Address can't be blank</span> : ""}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={0.4} display={"flex"} sx={{ height: "44.11px" }} alignItems={"center"}>
                      <IconButton style={{ marginLeft: '-40px' }}>
                        <MyLocationIcon fontSize="large" color={values.streetAddress !== "" && values.streetAddress !== undefined ? "info" : "secondary"} onClick={() => values.streetAddress !== "" && values.streetAddress !== undefined ? handleDisplayDialogeMap() : ""}
                        />
                      </IconButton>

                    </Grid>

                    <Grid item xs={12} lg={3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Address Type</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "44.11px" }}
                            label="Customer Type"
                            onChange={handleChange("addressType")}
                            value={values.addressType}
                          >
                            {/* <MenuItem value="">Select..</MenuItem> */}
                            <MenuItem value="Home">Home</MenuItem>
                            <MenuItem value="Office">Office</MenuItem>
                            <MenuItem value="Other">Other</MenuItem>

                          </Select>

                        </FormControl>
                        {userTypeErr ? <span style={errMsg}>Customer Type can't be blank</span> : ""}
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="City"
                            variant="outlined"
                            fullWidth
                            disabled
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 30
                            }}
                            value={values.city}
                            onChange={(e) => setValues({ ...values, city: e.target.value })}
                          />
                          {cityErr ? <span style={errMsg}>City can't be blank</span> : ""}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Zip Code"
                            variant="outlined"
                            fullWidth
                            disabled
                            inputProps={{
                              pattern: "^[0-9]+$",
                              maxLength: 4
                            }}
                            value={values.zipCode}
                            onChange={(e) => setValues({ ...values, zipCode: e.target.value })}
                          />
                          {zipCodeErr !== "" ? <span style={errMsg}>{zipCodeErr}</span> : ""}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Country</InputLabel>

                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "44.11px" }}
                            label="Country"
                            disabled
                            // onChange={handleChange("countryId")}
                            value={values.countryId}
                            onChange={(e) => setValues({ ...values, countryId: e.target.value })}
                          >
                            {country}
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">State</InputLabel>

                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "44.11px" }}
                            label="State"
                            disabled
                            // onChange={handleChange("stateId")}
                            value={values.stateId}
                            onChange={(e) => setValues({ ...values, stateId: e.target.value })}
                          >
                            {state}
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                  </Grid>
                </MDBox>
              </Card>

            </Grid>
          </Grid>
          <Grid
            container
            mt={2}
            columnSpacing={4}
            alignItems="center"
            display="flex"
            justifyContent="center"
          >
            <Grid item xs={12} md={4} spacing={2} lg={1.2}>
              <Link to={sessionStorage.getItem("ORDER_ROUTE")}>
                <MDButton
                  className="btn-block center-container-btn btn-warning btn-back rightSpace"
                  color="warning"
                  fullWidth
                >
                  Cancel
                </MDButton>
              </Link>
            </Grid>
            <Grid item xs={12} md={4} spacing={2} lg={1.2}>
              <MDButton
                rel="noreferrer"
                variant="gradient"
                color="success"
                fullWidth
                onClick={addCustomer}
              >
                Save
              </MDButton>
            </Grid>
          </Grid>
        </form>
      </MDBox>
      <LoadingModal loading={loading} />
      <DisplayMapModal
        open={displayDialogemap}
        long={locationLongitude}
        lat={locationLatitude}
        handleDelete={handleDisplay}
        handleCancel={handleCancel2("handleCancel")}
        onCoordinateChange={handleCoordinateChange}
        closeModalClick={handleCancel("closeModalClick")}
      />
    </DashboardLayout >
  );
}

export default AddAddressHistory;
